/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"InvitedAppShortcutsRecommendationsQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery",
	"bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_3",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_5",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_158",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_159",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_160",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_161",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_162",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"relay_ApprovalsContextApprovalsDataQuery",
	"relay_ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"relay_ArchivedPageBannerV2ArchivedPageBannerQuery",
	"relay_BlogTreeRootComponentQuery",
	"relay_CollabDraftQuery",
	"relay_ContentBlogUnifiedQuery",
	"relay_ContentHeaderPresenceContentSettingsQuery",
	"relay_ContentHeaderUnifiedQuery",
	"relay_ContentPrerequisitesQuery",
	"relay_ContentTypesHeaderQuery",
	"relay_ContentUnifiedQuery",
	"relay_ContentUnifiedWithSpaceKeyQuery",
	"relay_CoverPictureQuery",
	"relay_CustomHeaderFooterQuery",
	"relay_EditContentButtonQuery",
	"relay_EditorContentStateQuery",
	"relay_EditorPreferencesQuery",
	"relay_EmojiTitleQuery",
	"relay_EndOfPageRecommendationQuery",
	"relay_FollowingFeedWithSortByStorageSnippetsQuery",
	"relay_FooterCreateButtonsQuery",
	"relay_GlobalNavigationComponentQuery",
	"relay_GrantAccessDialogLoaderQuery",
	"relay_HomeRecentWorkQuery",
	"relay_InlineCommentsFocusedInlineCommentQuery",
	"relay_InvitedAppShortcutsRecommendationsQuery",
	"relay_LegacyMacroRendererQueryBodyQuery",
	"relay_LivePagesByLineLastUpdatedQuery",
	"relay_NativeCollabQuery",
	"relay_NotFoundContainerQuery",
	"relay_NotificationsButtonQuery",
	"relay_PageRestrictionsContextQuery",
	"relay_PageTreeQuery",
	"relay_PageTreeQueryWithSpaceKeyQuery",
	"relay_PermissionCheckAddCommentQuery",
	"relay_PersistentInviteEligibleQuery",
	"relay_PersonalizedTemplatesV2AllTemplatesQuery",
	"relay_PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"relay_ReactionsContentQuery",
	"relay_RendererContentStateQuery",
	"relay_RestrictedPageWithCanViewQuery",
	"relay_ScreenQuery",
	"relay_SiteInformationQuery",
	"relay_SmartCreateFeedbackBannerQuery",
	"relay_SmartCreatePageEditorDataWrapperComponentQuery",
	"relay_SpaceNavigationQuery",
	"relay_SpaceOverviewIdQuery",
	"relay_SpaceOverviewQuery",
	"relay_SpaceQuery",
	"relay_SpaceRestrictionCheckQuery",
	"relay_ThemeQuery",
	"relay_TopNavigationQuery",
	"relay_ViewSpaceExternalCollaboratorsDialogQuery",
	"relay_WebItemLocationQuery_page.metadata.banner",
	"relay_WebItemLocationQuery_system.content.byline",
	"relay_WebItemLocationQuery_system.header_left",
	"relay_WebItemLocationQuery_system.user",
	"relay_WebPanelLocationQuery_atl.footer",
	"relay_WebPanelLocationQuery_atl.general",
	"relay_WebPanelLocationQuery_atl.page.content.footer.actions",
	"relay_WelcomeMessagesQuery",
	"relay_WhiteboardUnifiedQuery",
	"relay_contentAppearanceQuery",
	"relay_fetchMentionsProviderDataQuery",
	"relay_graphqlHelpersDSPIsActionEnabledForContentQuery",
	"relay_graphqlHelpersFetchMediaTokenQuery",
	"relay_graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
	"relay_loomUserPermissionQuery",
	"relay_multiMacroQueryWithAppKeyQuery",
	"relay_onboardingStateGetOnboardingStateQuery",
	"relay_onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"relay_onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"relay_onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_5",
	"relay_onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"relay_onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"relay_onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"relay_onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"relay_onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_159",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_160",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_161",
	"relay_onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_162",
	"relay_preloadAutohighlightsQuery",
	"relay_preloadContentSmartLinksQuery",
	"relay_preloadCreateSpaceQuery",
	"relay_preloadEditButtonWithSpaceKeyQuery",
	"relay_preloadEditorNodeDataProvidersDataQuery",
	"relay_preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"relay_preloadPendingRequestExistsQuery",
	"relay_preloadPersonalSpaceDetailsQuery",
	"relay_preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"relay_preloadSpaceBlogCountQuery",
	"relay_preloadTemplatesCollectionEligibleQuery",
	"relay_shortcutsSmartLinksQuery",
	"relay_useAnalyticsByLineQuery",
	"relay_useAudioContentQuery",
	"relay_useBlogPostsQueryQuery",
	"relay_useConfluenceStandardToPremiumExperimentQuery",
	"relay_useConnectorOnboardingStateQuery",
	"relay_useConnectorOnboardingTeamTypeQuery",
	"relay_useConnectorStatesQuery",
	"relay_useContentClassificationContentDataClassificationQuery",
	"relay_useEditorContentModeValueQuery",
	"relay_useEmojiEverSetPropertyQuery",
	"relay_useFabricEligibilityMigrationQuery",
	"relay_useFeatureDiscoveryFeatureDiscoveryQuery",
	"relay_useFeedTypeSelectorRefreshQuery",
	"relay_useGetCurrentStorageUsageQuery",
	"relay_useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"relay_useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"relay_useHomeWidgetStateQuery",
	"relay_useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"relay_useIsLoomEntryPointsEnabledQuery",
	"relay_useIsUserViewingSpaceAsAnonQuery",
	"relay_useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"relay_useLoomTenantProvisionStatusQuery",
	"relay_usePopularFeedWithTimeGranularityStorageQuery",
	"relay_usePreloadCommentButtonQuery",
	"relay_useReadTimeQuery",
	"relay_useRegisterAdminAnnouncementBannerQuery",
	"relay_useShareAndRestrictButtonDataQuery",
	"relay_useSpaceBaseQueryBaseQuery",
	"relay_useSpaceDetailQuery",
	"relay_useSpaceEnabledContentTypesQuery",
	"relay_useSpaceViewsDataSpaceRootQuery",
	"relay_useSpaceViewsOptionsPersistenceQuery",
	"relay_useSpacesDataMyVisitedSpacesQuery",
	"relay_useSpacesDataStarredSpacesQuery",
	"relay_useTitleContentPropertiesForEditorQuery",
	"relay_useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"relay_useTitleContentPropertiesForPublishedPageQuery",
	"relay_useUserByLicensedProductsQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "cfaf3d67ffebff3f5beb3ffeefffb7cbfa33d0d7efbede73efa7bfadd8d5fbed9fe277cffb7c",
	"prod-apne2": "cfaf3d6fffebfd3f5beb3ffeefffffcbfa33fad7ebffeefbffefbfaff8d7fbef9bee7fcffb7c",
	"prod-apse": "cfff3d7fffebff3f5beb3ffeefffbfcbfbb3fbd7ffffeefbffffffadf8dffbef9fe27fcffb7d",
	"prod-apse2": "cfff3d6fffebffffdfeb3ffeefffffebfa33fbd7fffffefbffefffadf8dffbff9fee7fdffb7f",
	"prod-apsouth": "cfbf3d67ffebff3fdbeb3ffeefffffcbf633fad7effffefbffefb7bdf8d7fbffdbee7fcffb7e",
	"prod-cacentral": "8fff3d77ffefff3fdfeb3ffeefffffcbfab3dadfeffffefbffefbfadf8f7fbff9bfeffcffb7e",
	"prod-east": "cfef3f5fffefff7fdfeb3ffeffffffeffbf3fbdffffffffbffffffaffffffbff9ffeffdffb7e",
	"prod-eucentral": "cfef3f6fffebffbf5feb3ffeefffffeffb33fbd7ffffeefbffffffaffbdffbff9fee7fdffb7f",
	"prod-eucentral2": "cfef3d63ffebffbf5beb3dfeefffbfcbfa13d0d7efbedeebffefbfadf8d5fbed9be27fcffb7c",
	"prod-euwest": "cfef3f5fffebffffffeb3ffeefffffeffbf3fbd7fffffefbffffffaff8fffbff9feeffdffb7f",
	"prod-euwest2": "cfff3d7fffefff3fdfeb3ffeefffffcbfeb3fad7effffefbffefbfadf8f7fbff9bee7fcffb7f",
	"prod-west2": "cfef3dcfffefffffdbab3ffeefffffeffb33ffdffffffefbffffffedf8fffbef9feeffdffb7d",
	"stg-east": "cad94d05956410374882a201008405da1003d8990ccede7f6fc7b6b8d9ff237b43420045f520"
};

export const generatedAt: string | null = "2026-08-12T03:07:30.568Z";
